import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import {
    UserImg,
    UploadIcon
} from "../../Constant/Index";
const EditProfileTherapist = () => {
    const [firstname, setFirstname] = useState('Alexander');

    const handleInputChange = (e) => {
        setFirstname(e.target.value);
    };
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/therapist/home');
    };
    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <div className="profile-box">
                                    <div className="top-heading d-flex gap-4 align-items-center pb-4">
                                        <h3 className="md-heading min-width-fit mb-0">Edit Info</h3>
                                        <hr className="w-100" />
                                    </div>
                                    <div className="userphoto-edit pb-3">
                                        <div className="photo">
                                            <figure>
                                                <img src={UserImg} alt="" className="img-here" />
                                                <label htmlFor="changeimage" className="upload">
                                                    <img src={UploadIcon} alt="changeimage" />
                                                    <input type="file" name="changeimage" id="changeimage" hidden />
                                                </label>
                                            </figure>
                                            <div className="data">
                                                <span className="username">Photo</span>
                                                <span className="change-upload"><label htmlFor="" className="chang-img">Upload / Change Photo</label></span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="update-form">
                                        <form className="form-area" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="firstname" id="firstname" className="form-control" value={firstname} onChange={handleInputChange} placeholder="First Name" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="" id="" className="form-control" placeholder="Last Name" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <select name="" id="" className="form-control">
                                                            <option value="Gender">Gender</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                        </select>
                                                        {/* <input type="text" name="" id="" className="form-control" placeholder="Gender" /> */}
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="email" name="" id="" className="form-control" placeholder="Email Address" />
                                                    </div>
                                                </div>
                                                
                                                <div className="col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="" id="" className="form-control" placeholder="Contact Number" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="" id="" className="form-control" placeholder="Date Of Birth" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="" id="" className="form-control" placeholder="Country" />
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="" id="" className="form-control" placeholder="Address*" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="" id="" className="form-control" placeholder="State" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="" id="" className="form-control" placeholder="City" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group">
                                                        <input type="text" name="" id="" className="form-control" placeholder="Zip Code" />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-4 text-end" >
                                                    <button className="btn" type="submit">Save Changes</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default EditProfileTherapist;